<template>
    <div class="apprentice-simple-card organizations container-with-shadow">
        <design-2021-apprentice-data-table
            v-if="organizations.length"
            :fields="fields"
            :items="organizations">
            <template v-slot:options>
                <b-button
                    class="btn-add btn-new-organization"
                    v-b-modal="'organization-create-modal'"
                    variant="primary">
                    {{ $t('organization.add_organization') }}
                </b-button>
            </template>

            <template v-slot:cell(action)="row">
                <div class="actions">
                    <b-button
                        class="btn-open remove-icon-margin btn-open-organization"
                        variant="primary-icon-only"
                        :v-b-tooltip="$t('organization.view_organization')"
                        @click="openOrganization(row.item)">
                    </b-button>
                    <b-button
                        class="btn-edit remove-icon-margin btn-edit-organization"
                        variant="primary-icon-only"
                        @click="onEdit(row.item)"
                        :v-b-tooltip="$t('organization.manage_organization')">
                    </b-button>
                    <b-button
                        class="btn-remove remove-icon-margin btn-remove-organization"
                        variant="danger-icon-only"
                        @click="onRemove(row.item.id)"
                        :v-b-tooltip="$t('organization.delete_organization')">
                    </b-button>

                    <design-2021-organization-edit-modal-component
                        :organization-id="row.item.id"
                        :organisation-name="row.item.name"
                        @update-organization-list="updateOrganization">
                    </design-2021-organization-edit-modal-component>
                </div>
            </template>
        </design-2021-apprentice-data-table>

        <div
            class="apprentice-table-tools no-organizations not-found empty-organization-list"
            v-else>
            <div
                class="btn-add-circle icon"
                v-b-modal="'organization-create-modal'"></div>

            <div class="alert-notice">{{ $t('organization.no_organizations_found') }}</div>
        </div>

        <design-2021-organization-create-modal-component @add-organization="addOrganization">
        </design-2021-organization-create-modal-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-organization-index-component',
    props: {
        organizationsIn: Array,
    },
    data() {
        return {
            fields: [
                {
                    key: 'name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'action',
                    label: this.$t('common.actions'),
                },
            ],
            organizations: this.organizationsIn,
        };
    },
    methods: {
        onEdit(organization) {
            window.location.href = this.routes.organizationSettings(organization.id);
        },
        openOrganization(organization) {
            window.location.href = baseUrl + '/organization/select/' + organization.id;
        },
        onRemove(id) {
            this.alert
                .confirm(
                    this.$t('organization.delete_organization'),
                    this.$t('organization.are_you_sure_you_want_to_delete_this_organization'),
                )
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }

                    this.alert.saving();
                    this.axios.delete(this.routes.organizationRemove(id)).then(
                        (response) => {
                            this.organizations = this.organizations.filter((organization) => {
                                return organization.id !== id;
                            });
                            this.alert.success();
                        },
                        (error) => {
                            return this.alert.ajaxError(error);
                        },
                    );
                });
        },

        updateOrganization(data) {
            for (const [needle, organization] of this.organizations.entries()) {
                if (organization.id === data.id) {
                    this.organizations[needle].name = data.name;
                    break;
                }
            }
        },

        addOrganization(organization) {
            this.organizations.push(organization);
        },
    },
};
</script>

<style scoped lang="scss">
.no-organizations .options {
    text-align: right;
    margin-bottom: 21px;
}

.actions {
    display: flex;
    align-items: center;

    .btn {
        &:before {
            margin-right: 0;
        }
    }

    button:not(:last-child) {
        margin-right: map-get($grid-gutter-spacing, 'fifteen');
    }
}
</style>
